import * as React from 'react';
import * as styles from './styles.css';

import { Button, IconSearch16 } from '@cian/ui-kit';

export interface ISearchTextButtonProps {
  onClick(): void;
}

export function SearchTextButton({ onClick }: ISearchTextButtonProps) {
  return (
    <div className={styles['container']}>
      <Button
        theme="stroke_secondary"
        size="M"
        beforeIcon={<IconSearch16 color="superblack_60" />}
        onClick={onClick}
      ></Button>
    </div>
  );
}
